import { joinClassNames } from "@utils/helpers";
import { useState } from "react";

interface Props {
  min?: number;
  max: number;
  defaultValue?: number;
  onChange: (value: number) => void;
  disabled?: boolean;
}

const NativeNumberDropdown = ({
  min = 1,
  max,
  defaultValue,
  onChange,
  disabled,
}: Props) => {
  const [selectedNumber, setSelectedNumber] = useState(defaultValue);

  return (
    <select
      value={selectedNumber}
      className={joinClassNames(
        "flex items-center justify-between w-24 px-2 py-2 border border-gray-300 rounded",
        disabled ? "bg-gray-200 text-gray-400" : "bg-white text-black"
      )}
      disabled={disabled}
      onChange={(value) => {
        const selectedNum = parseInt(value.target.value);
        setSelectedNumber(selectedNum);
        onChange(selectedNum);
      }}
    >
      {Array.from({ length: max - min + 1 }, (_, index) => index + min).map(
        (value) => (
          <option key={value} value={value}>
            {value}
          </option>
        )
      )}
    </select>
  );
};

export default NativeNumberDropdown;
